/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useEffect, useCallback, useRef, useImperativeHandle } from "react";
import axios from 'util/axios';

import { table_render, html_render } from "../Functions";

import { useDispatch, useSelector } from "react-redux";



const ReviewContent = (props) => {
    const [Data, SetData] = useState();
    const [List, SetList] = useState({ content: [], table: [], image: [] });

    const dispatch = useDispatch();
    const userSelector = useSelector((store) => store.user);

    const containerRef = useRef(null);

    const getDocData = async () => {
        dispatch({ type: "LOADING_ON" });
        try {
            const { location } = window;
            const params = new URLSearchParams(location.search);
            const geneCode = params.get("geneCode")
            const revision = params.get("revision")
            const tempYn = params.get("tempYn");

            const docData = await axios
                .post(process.env.REACT_APP_API + "/diff/retrieveGenerateTemplateForSave", { geneCode, revision, tempYn })
                .then((Response) => Response.data.data);

            const compareData = await axios
                .post(process.env.REACT_APP_API + "/pcsDiff/diff", { pcsCode: geneCode, afterRevision: revision, tempYn })
                .then((Response) => Response.data.data);

            SetData({ doc: docData, compareData: compareData });
        } catch (e) {
            console.error(e);
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
    };

    useEffect(() => {
        getDocData();
    }, []);

    const MainRender = useMemo(() => {

        if (!Data?.doc) {
            return <h1>No Data</h1>;
        }

        const { doc, compareData } = Data;
        const { descriptionDiff, sheetDiff } = compareData;


        const descInfo = doc?.desc[0];

        const Header = html_render(descriptionDiff?.headerDescription);
        const Common = html_render(descriptionDiff?.commonDescription);
        const Footer = html_render(descriptionDiff?.footerDescription);
        const descInfoStr = `${descInfo?.descCode}|${descInfo?.revision}|${descInfo?.tempYn}`;

        let shinfo = "";
        
        const Tables = doc?.sheetList?.map((tbl, index) => {
            const sheetInfo = `${tbl.master?.sheetCode}|${tbl.master?.revision}|${tbl?.["tempYn"]}`;
            if (!shinfo) shinfo = sheetInfo;

            const sheetCode = tbl.master?.sheetCode?.toString().toUpperCase();
            let reviewData = [];

            let desc;

            const diffData = sheetDiff.modifySheetList[index].result ?? {};

            desc = html_render({webContent: diffData?.webContentAfter, ...diffData});

            let htmlStr = [];

            const isExternal = userSelector.isExternal;

            if (tbl["composition"] && tbl["composition"].length > 0) {
                htmlStr.push(table_render("composition", tbl, isExternal, diffData.compositionD));
            }
            htmlStr.push(table_render("in", tbl, isExternal, diffData.inD, diffData.subD));
            htmlStr.push(table_render("out", tbl, isExternal, diffData.outD, diffData.subD));
            htmlStr.push(table_render("qc", tbl, isExternal, diffData.qcD, diffData.subD));

            return {
                tables: htmlStr,
                desc: desc,
                sheetInfo: sheetInfo,
                tempYn: tbl?.["tempYn"],
            };
        });
        return (
            <>
                <div
                    className={`pdf-page ck-content`}
                    data-sheetinfo={`${descInfoStr}`}
                    data-revtype={`H`}
                    dangerouslySetInnerHTML={{ __html: Header }}
                ></div>
                <div
                    className={`pdf-page ck-content`}
                    data-sheetinfo={`${descInfoStr}`}
                    data-revtype={`C`}
                    dangerouslySetInnerHTML={{ __html: Common }}
                ></div>
                {Tables?.map((tbl, i) => {
                    return (
                        <React.Fragment key={"pdfpreview" + i}>
                            {tbl.desc && (
                                <div
                                    className={`pdf-page ck-content`}
                                    data-sheetinfo={`${tbl.sheetInfo}`}
                                    data-revtype={`D`}
                                    dangerouslySetInnerHTML={{ __html: tbl.desc }}
                                ></div>
                            )}
                            {tbl.tables?.map((tblInner, i2) => {
                                if (tblInner) {
                                    return (
                                        <div
                                            key={"pdfpreview" + i + "_" + i2}
                                            className={`pdf-page ck-content data-tables`}
                                            data-sheetinfo={`${tbl.sheetInfo}`}
                                            dangerouslySetInnerHTML={{ __html: tblInner }}
                                        ></div>
                                    );
                                } else return null;
                            })}
                        </React.Fragment>
                    );
                })}
                <div
                    className={`pdf-page ck-content`}
                    data-revtype={`F`}
                    data-sheetinfo={`${descInfoStr}`}
                    suppressHydrationWarning
                    dangerouslySetInnerHTML={{ __html: Footer }}
                ></div>
            </>
        );
    }, [Data]);

    useEffect(() => {
        if (Data?.doc) {
            document.querySelectorAll("span")?.forEach((e) => {
                const color = e.style.backgroundColor;
                if (color) {
                    e.style.backgroundColor = "transparent";
                    e.style.textShadow = "0px 0px 10px " + color;
                }
            });

            let cnt = 0;
            let cnt2 = 0;
            let cnt3 = 0;
            let cnt4 = 0;

            let tCnt = 0;
            let tImg = 0;
            const contentList = { content: [], table: [], image: [] };
            // containerRef.current?.querySelectorAll("h1, h2, h3, h4, figcaption")?.forEach((e) => {
            //     console.log(e);
            //     if (e.tagName.toUpperCase() === "FIGCAPTION") {
            //         const figure = e.closest("figure");
            //         const isTable = figure.classList.contains("table");
            //         const isImage = figure.classList.contains("image");
            //         if (isTable) {
            //             tCnt++;
            //             e.innerHTML = `Table ${tCnt}. ` + e.innerHTML.toString().replaceAll(/^Table [\d.]+\. /g, "");
            //             contentList.table.push({ innerHTML: e, id: `tbl${tCnt}`, tbltp: e.dataset.tblnm && e.dataset.tblnm + e.dataset.tbltp });
            //             e.id = `tbl${tCnt}`;
            //         } else if (isImage) {
            //             tImg++;
            //             e.innerHTML = `Figure ${tImg}. ` + e.innerHTML.toString().replaceAll(/^Figure [\d.]+\. /g, "");
            //             contentList.image.push({ innerHTML: e, id: `img${tImg}` });
            //             e.id = `img${tCnt}`;
            //         }
            //     } else {
            //         let isDataTable = e.classList.contains("exclude_heading");
            //         // let visible = true;
            //         switch (e.tagName.toUpperCase()) {
            //             case "H1":
            //                 cnt++;
            //                 e.innerHTML = `${cnt}. ` + e.innerHTML.toString().replaceAll(/^[\d. ]+\./g, "");
            //                 cnt2 = 0;
            //                 cnt3 = 0;
            //                 cnt4 = 0;
            //                 break;
            //             case "H2":
            //                 cnt2++;
            //                 e.innerHTML = `${cnt}.${cnt2}. ` + e.innerHTML.toString().replaceAll(/^[\d. ]+\./g, "");

            //                 cnt3 = 0;
            //                 cnt4 = 0;
            //                 break;
            //             case "H3":
            //                 cnt3++;
            //                 e.innerHTML = `${cnt}.${cnt2}.${cnt3}. ` + e.innerHTML.toString().replaceAll(/^[\d. ]+\./g, "");

            //                 cnt4 = 0;
            //                 isDataTable = true;
            //                 break;
            //             case "H4":
            //                 cnt4++;
            //                 e.innerHTML =
            //                     `${cnt}.${cnt2}.${cnt3}.${cnt4}. ` + e.innerHTML.toString().replaceAll(/^[\d. ]+\./g, "");
            //                 isDataTable = true;
            //                 break;
            //             default:
            //                 break;
            //         }
            //         e.id = `${cnt}_${cnt2}_${cnt3}_${cnt4}`;
            //         contentList.content.push({
            //             innerHTML: e,
            //             isDataTable: isDataTable,
            //             id: `${cnt}_${cnt2}_${cnt3}_${cnt4}`,
            //         });
            //     }
            // });

            const ref_list = [...contentList.table, ...contentList.image];
            document.querySelectorAll("a.tblref").forEach((e) => {
                try {
                    const tr = e.dataset.tblref?.toLowerCase().replace(/^\[:(.*):\]$/, "$1").split("::");
                    let ref;
                    if (tr.length > 2) {
                        const qs = (tr[0] + tr[1]).toUpperCase();
                        const tbl = tr[2].toUpperCase();
                        ref = ref_list.filter(ft => ft.tbltp).find(fi => fi.tbltp === qs + tbl);
                    } else {
                        const tbl_name = tr[tr.length - 1];
                        ref = ref_list.find(f => {
                            let ele = f.innerHTML?.innerText;
                            ele = ele.replace(/^(table|figure) [0-9]+\. /i, '').trim().toLowerCase();
                            return ele.startsWith(tbl_name.toLowerCase());
                        });
                    }

                    try {
                        if (ref) {
                            e.innerHTML = "[" + ref.innerHTML.innerText + "]";
                            e.href = "#" + ref.id;

                            e.classList.remove("tblref");
                        } else {
                            e.innerHTML = "[#REFERROR!]"
                        }
                    } catch (e) {
                        throw new Error(e)
                    }
                } catch (e) { console.error(e) }
            })


            // Table 깨짐 수정
            document.querySelectorAll("*:not(.fixfigure) > figure").forEach((e) => {
                try {
                    if (e.style?.width.includes("%")) {
                        const widthPercent = parseFloat(e.style.width.replaceAll(/%$/g, ""));
                        if (widthPercent > 100) {
                            e.style.width = "100%";
                        }
                    }
                    if (e.style?.height) {
                        e.style.height = null;
                    }
                    e.outerHTML = `<div class='fixfigure' style="width: 100%; display: block">${e.outerHTML}</div>`;
                } catch (e) {
                    console.error(e);
                }
            });

            // getCompareData();
        }
    }, [Data]);

    return (
        <>
            <div style={{ width: "100%", paddingTop: "100px" }}>
                <div id="review-container" ref={containerRef}>
                    {/* {ListRender} */}

                    {MainRender}

                </div>
            </div>

        </>
    );
};

// const areEquals = (prev, next) => {
//     return JSON.stringify(prev) === JSON.stringify(next);
// };
export default ReviewContent
// export default React.memo(ReviewContent, areEquals);
